import React from "react";
import "./Description.css";

const Description = ({ children }) => {
  return <span className="description">{children}</span>;
};

export default Description;
